/**
 * Model for component Error502
 * @returns nothing
 */

class Model {
}

export default Model